<template>
  <div id="world">
    <div class="row mt-md-5">
      <div class="col-md-12">
        <img src="/static/images/world/sekai_main.jpg" class="img-fluid" alt="おひさまキッチンのせかいへようこそ">
      </div>
      <div class="col-md-12 m-3 text-center">
        <p class="caption">ふしぎでおいしいせかいが、ひろがってるよ。</p>
      </div>
      <div class="col-md-3 col-6 mb-5">
        <div>
          <router-link v-b-toggle.collapse-1 to="/introduce.html">
            <img src="/static/images/world/sekai_syokai.jpg" class="img-fluid" alt="">
          </router-link>
        </div>
        <div class="title">どうぶつさんしょうかい</div>
      </div>
      <div class="col-md-3 col-6 mb-5">
        <div>
          <a href="/ohisama/ehon.html">
            <img src="/static/images/world/sekai_anime.jpg" class="img-fluid" alt="">
          </a>
        </div>
        <div class="title">どうぶつさんアニメ</div>
      </div>
      <div class="col-md-3 col-6 mb-5">
        <div>
          <a href="/ohisama/map.html">
            <img src="/static/images/world/sekai_map.jpg" class="img-fluid" alt="">
          </a>
        </div>
        <div class="title">おひさまキッチンの地図</div>
      </div>
      <div class="col-md-3 col-6 mb-5">
        <div>
          <a href="/ohisama/ugokupandakun.html">
            <img src="/static/images/world/sekai_movepanda.jpg" class="img-fluid" alt="">
          </a>
        </div>
        <div class="title">うごくパンダくん</div>
      </div>
      <div class="col-md-3 col-6 mb-5">
        <div>
          <a href="/ohisama/wallpaper.html">
            <img src="/static/images/world/sekai_kabegami.jpg" class="img-fluid" alt="">
          </a>
        </div>
        <div class="title">壁紙</div>
      </div>
      <div class="col-md-3 col-6 mb-5">
        <div>
          <a href="/ohisama/201411_ehon/book.html">
            <img src="/static/images/world/sekai_babybook.jpg" class="img-fluid" alt="">
          </a>
        </div>
        <div class="title">ベビーパンダちゃんの絵本</div>
      </div>
      <div class="col-md-3 col-6 mb-5">
        <div>
          <a href="/ohisama/spice.html">
            <img src="/static/images/world/sekai_sogen.jpg" class="img-fluid" alt="">
          </a>
        </div>
        <div class="title">香りの草原かんさつノート</div>
      </div>
      <div class="col-md-3 col-6 mb-5">
        <div>
          <a href="/ohisama/tree.html">
            <img src="/static/images/world/sekai_tree.jpg" class="img-fluid" alt="">
          </a>
        </div>
        <div class="title">つぶや木、ささや木、イン木</div>
      </div>
      <div class="col-md-3 col-6">
        <div>
          <a href="/namaketodoke/" target="_blank">
            <img src="/static/images/world/sekai_namakemono.jpg" class="img-fluid" alt="">
          </a>
        </div>
        <div class="title">なまけもののとどけもの</div>
      </div>
      <div class="col-md-3 col-6">
        <div>
          <a href="/ohisama/twitter_ehon/">
            <img src="/static/images/world/sekai_twitter.jpg" class="img-fluid" alt="">
          </a>
        </div>
        <div class="title">Twitter物語</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    title: 'おひさまキッチンの世界',
    name: 'world',
    updated: function() {
      this.$nextTick(function () {
        try {
          FONTPLUS.reload();
        } catch (error) {
          console.log(error.message);
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sekai.vue